import Polyglot from "node-polyglot";
import getWindow from "./utils/window";
import { getBreadcrumbsForAnalytics } from "./utils/analyticsBreadcrumbs";
import { getParamFromReferrer } from "./utils/getParamFromReferrer";
import buildUrlParamsObject from "./buildUrlParamsObject";
import getConfig from "./config";
import { STYLING_LOOK, HERO_LOOK } from "./constants";

let runtimeConstants;

export default function getRuntimeConstants() {
  if (!getWindow()?.asos) {
    return {};
  }

  if (!runtimeConstants) {
    const {
      breadcrumbsData,
      defaultAnalyticsBreadcrumbs,
      looks,
      translations: phrases,
      structuredDataV2EnabledStores = [],
      oosVariantSelectionEnabledStores = [],
      features,
      ...rest
    } = getConfig();

    const translations = new Polyglot({
      phrases,
      locale: getWindow()
        .asos.webContext.getWebContext()
        .browseLanguage.split("-")[0],
    });

    const hostAndPath = getWindow()
      .location.href.split("?")[0]
      .replace(/\/$/, "");
    const isMixAndMatch = getWindow().location.pathname.includes("/grp/");
    const urlParams = buildUrlParamsObject();

    const canonicalUrl = getWindow().document.querySelector(
      "link[rel=canonical]"
    ).href;

    const webContext = getWindow().asos.webContext.getWebContext();

    const referrerData = {
      searchQuery: getParamFromReferrer({ param: "q" }),
      cid: getParamFromReferrer({ param: "cid" }),
    };

    const analyticsBreadcrumbs = getBreadcrumbsForAnalytics({
      breadcrumbsData,
      defaultAnalyticsBreadcrumbs,
      referrerData,
    });

    const heroLook = looks?.find((look) => look.type === HERO_LOOK);

    const looksData =
      looks && looks.length
        ? {
            lookImageUrl: looks[0]?.lookImageUrl,
            looksProductsFromServer: looks
              .filter((look) => look.type !== STYLING_LOOK)
              .flatMap((look) => look.products || []),
          }
        : undefined;

    const stylingLooksData = looks?.length
      ? [
          ...(looksData?.looksProductsFromServer.length
            ? [
                {
                  id: heroLook?.id,
                  looksProductsFromServer: looksData.looksProductsFromServer,
                  isHeroLook: true,
                  labelTranslationKey: heroLook?.endUseLabel,
                },
              ]
            : []),
          ...looks
            .filter((look) => look.type === STYLING_LOOK)
            .map((stylingLook) => {
              return {
                id: stylingLook.id,
                stylingLookProductsFromServer: stylingLook.products || [],
                isHeroLook: false,
                labelTranslationKey: stylingLook.endUseLabel,
              };
            }),
        ]
      : undefined;

    const oosVariantsAreSelectable = oosVariantSelectionEnabledStores.includes(
      webContext.storeId.toLowerCase()
    );
    const useStructuredDataV2 = structuredDataV2EnabledStores.includes(
      webContext.storeId.toLowerCase()
    );

    runtimeConstants = {
      ...rest,
      hostAndPath,
      canonicalUrl,
      urlParams,
      isMixAndMatch,
      translations,
      webContext,
      analyticsBreadcrumbs,
      breadcrumbsData,
      referrerData,
      looksData,
      stylingLooksData,
      oosVariantsAreSelectable,
      useStructuredDataV2,
      storeCode: webContext.storeId,
      features,
    };
  }
  return runtimeConstants;
}
